import posthog from 'posthog-js';
import { logError } from '../components/logger/sentryLogger';

export const capturePHEvents = (eventName, eventData) => {
  try {
    posthog.capture(eventName, eventData);
  } catch (error) {
    logError(error, 'Posthog Error', { eventName, eventData });
  }
};

export const capturePHIdentify = (userId, userData) => {
  try {
    posthog.identify(userId, userData);
  } catch (error) {
    logError(error, 'Posthog Error at capturePHIdentify');
  }
};
